import { City } from "shared/types/citiesList";

export function getCitiesValues(city: City[] | null) {
  const cities = {} as Record<string, string>;

  if (city && city.length > 0) {
    Object.keys(city).forEach((key: string) => {
      const { geoname_id, city_name } = city[Number(key)];
      cities[geoname_id] = city_name;
    });
  }

  return cities;
}

export function getCity(
  city: string | number,
  cities: City[] | null
): string | null {
  const cityList = getCitiesValues(cities);

  if (typeof cityList[city] === "undefined") {
    return null;
  }

  return cityList[city];
}
